import React, { useState } from "react";
import "./NotificationBoard.css";
import FormatDateTime from "../../../utils/formatDateTime/FormatDateTime.js";
import { useGlobalDialog } from "../../../contexts/GlobalDialogContext";
import NotificationsModal from "../../modalComponents/notificationsModal/NotificationsModal";
import { notifications } from "../../../config/constants";

const NotificationBoard = () => {
  const [visibleNotifications, setVisibleNotifications] = useState(
    notifications.slice(0, 8),
  ); // First 8 notifications

  const { openDialog } = useGlobalDialog();

  // Function to handle the "View Previous Notifications" click
  const handleViewAllNotifications = () => {
    openDialog(NotificationsModal, "All Notifications");
  };

  return (
    <section className="container notification-board-container">
      <h3 className="label">Notifications</h3>
      <div className="inner-container-first notification-list-container">
        <div className="scrollable-inner">
          <ul className="notification-list">
            {visibleNotifications.map((notification, index) => {
              const isNew =
                new Date() - new Date(notification.datetime) <
                4 *
                  24 *
                  60 *
                  60 *
                  1000; /* (days * hours * minutes * seconds * msec) */
              return (
                <li
                  key={index}
                  className={`notification-container ${isNew ? "shimmer-bg" : ""}`}
                >
                  <h3 className="h3-secondary notification-headline">
                    &#x2022; {notification.heading}
                    {isNew && <span>New</span>}
                  </h3>
                  <p className="notification-details">{notification.details}</p>
                  {notification.attachment && (
                    <a
                      className="detail-postfix"
                      href={notification.attachment}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <p className="paperclip-icon">&#128206;</p> View
                      Attachment
                    </a>
                  )}
                  <div className="notification-footer">
                    <p className="clock-icon">&#128336;</p>
                    <div>{FormatDateTime(notification.datetime)}</div>
                  </div>
                </li>
              );
            })}
          </ul>

          {/* Only show button if there are more than 8 notifications */}
          {notifications.length > 8 && (
            <button
              className="view-old-notifications"
              onClick={handleViewAllNotifications}
            >
              View All Notifications
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default NotificationBoard;
